import React from 'react';

function DescargaApp() {
    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-12 col-lg-10">
                    <h1 className="mb-4 text-center">Etapa de pruebas Zervicy</h1>

                    <div className="ratio ratio-16x9 mb-5 rounded overflow-hidden shadow-sm">
                        <iframe
                            src="https://www.youtube.com/embed/rLTIz3iOA1Q?rel=0"
                            title="Video etapa de pruebas Zervicy"
                            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                        />
                    </div>

                    <div className="mb-5">
                        <h2 className="mb-4">Paso 1: descarga la app</h2>

                        <div className="row g-4">
                            <div className="col-12 col-md-6">
                                <div className="card h-100 shadow-sm border-0">
                                    <div className="card-body d-flex flex-column">
                                        <div className="d-flex align-items-center gap-2 mb-3">
                                            <i className="bi bi-android2 fs-3" />
                                            <h3 className="h5 mb-0">Android</h3>
                                        </div>
                                        <p className="text-muted mb-4">
                                            Descarga la aplicación desde Google Play e instala la versión de prueba en tu dispositivo Android.
                                        </p>
                                        <a
                                            href="https://play.google.com/store/apps/details?id=com.zervicy.app"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="btn btn-dark mt-auto"
                                        >
                                            <i className="bi bi-google-play me-2" />
                                            Descargar en Android
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-6">
                                <div className="card h-100 shadow-sm border-0">
                                    <div className="card-body d-flex flex-column">
                                        <div className="d-flex align-items-center gap-2 mb-3">
                                            <i className="bi bi-apple fs-3" />
                                            <h3 className="h5 mb-0">iOS</h3>
                                        </div>
                                        <p className="text-muted mb-4">
                                            Descarga la aplicación desde TestFlight e instala la versión de prueba en tu iPhone.
                                        </p>
                                        <a
                                            href="https://testflight.apple.com/join/YUr2tVsj"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="btn btn-dark mt-auto"
                                        >
                                            <i className="bi bi-apple me-2" />
                                            Descargar en iPhone
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mb-5">
                        <h2 className="mb-3">Paso 2: utiliza la aplicación</h2>
                        <div className="card shadow-sm border-0">
                            <div className="card-body">
                                <p className="mb-3">
                                    Busca servicios, inicia sesión o regístrate y navega por la aplicación con tranquilidad.
                                </p>
                                <p className="mb-3">
                                    Si estás interesado, también puedes crear un servicio y probar ese flujo. Si no quieres crear uno, no es necesario: con buscar, explorar e interactuar con la aplicación es suficiente.
                                </p>
                                <p className="mb-0">
                                    Mientras la utilizas, piensa qué podría mejorar, qué te gustó y qué te pareció confuso o difícil de usar.
                                </p>
                                <div className="alert alert-light border mt-4 mb-0">
                                    <p className="mb-2 fw-semibold">
                                        Si deseas hacer pruebas de compras de prueba, utiliza estos datos para hacer un pago con tarjeta de crédito:
                                    </p>
                                    <p className="mb-1"><strong>T.C.</strong> 4242 4242 4242 4242</p>
                                    <p className="mb-1"><strong>Fecha:</strong> 02/28</p>
                                    <p className="mb-0"><strong>CVV:</strong> 123</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mb-5">
                        <h2 className="mb-3">Paso 3: deja un comentario</h2>
                        <div className="card shadow-sm border-0">
                            <div className="card-body">
                                <p className="mb-4">
                                    Puedes escribirme directamente y dejarme un comentario sobre lo que viste al momento de utilizar la aplicación: cambios, mejoras, errores o cualquier sugerencia.
                                </p>

                                <div className="d-flex flex-column flex-md-row gap-3">
                                    <a
                                        href="https://www.instagram.com/eduardoarias.co"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="btn btn-outline-dark"
                                    >
                                        <i className="bi bi-instagram me-2" />
                                        Instagram: @eduardoarias.co
                                    </a>

                                    <a
                                        href="https://wa.me/573502129660"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="btn btn-outline-success"
                                    >
                                        <i className="bi bi-whatsapp me-2" />
                                        WhatsApp
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="text-center">
                        <p className="lead mb-0">
                            Gracias por tomarte el tiempo de probar Zervicy y ayudarme a mejorar la aplicación.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DescargaApp;